import { createEnumHelper } from '@seiue/util'
import { ISearchFormItemType } from 'packages/components/DataTable'
import {
  EntryrecordLoginTypeEnum,
  FieldTypeEnum,
  ReflectionGenderEnum,
  ReflectionIdcardTypeEnum,
  ReflectionPupilTypeEnum,
  ReflectionRoleEnum,
  ReflectionStatusEnum,
} from 'packages/sdks-next/growp'

export enum IFormItemTypeEnum {
  Input = 'input',
  Select = 'select',
  Multi = 'multi',
  Date = 'date',
  Time = 'time',
  DateRange = 'dateRange',
  TextArea = 'textArea',
  Product = 'product',
  Filelist = 'filelist',
  Integer = 'integer',
  Address = 'address',
  Error = 'error',
  Radio = 'radio',
}

export const InfoTypeEnumToFormType = createEnumHelper(() => ({
  [FieldTypeEnum.String]: IFormItemTypeEnum.Input,
  [FieldTypeEnum.Single]: IFormItemTypeEnum.Select,
  [FieldTypeEnum.Multi]: IFormItemTypeEnum.Multi,
  [FieldTypeEnum.Product]: IFormItemTypeEnum.Product,
  [FieldTypeEnum.Time]: IFormItemTypeEnum.Time,
  [FieldTypeEnum.Date]: IFormItemTypeEnum.Date,
  [FieldTypeEnum.Text]: IFormItemTypeEnum.TextArea,
  [FieldTypeEnum.Attachment]: IFormItemTypeEnum.Filelist,
  [FieldTypeEnum.DateRange]: IFormItemTypeEnum.DateRange,
  [FieldTypeEnum.Address]: IFormItemTypeEnum.Address,
  [FieldTypeEnum.Integer]: IFormItemTypeEnum.Integer,
  [FieldTypeEnum.Describe]: IFormItemTypeEnum.Error,
  [FieldTypeEnum.PageBreak]: IFormItemTypeEnum.Error,
}))

export const InfoTypeEnumToSearchFormType = createEnumHelper(() => ({
  [FieldTypeEnum.String]: ISearchFormItemType.Input,
  [FieldTypeEnum.Single]: ISearchFormItemType.Select,
  [FieldTypeEnum.Multi]: ISearchFormItemType.Multi,
  [FieldTypeEnum.Product]: ISearchFormItemType.Null,
  [FieldTypeEnum.Time]: ISearchFormItemType.TimeRange,
  [FieldTypeEnum.Date]: ISearchFormItemType.DateRange,
  [FieldTypeEnum.DateRange]: ISearchFormItemType.Null,
  [FieldTypeEnum.Text]: ISearchFormItemType.TextArea,
  [FieldTypeEnum.Attachment]: ISearchFormItemType.Null,
  [FieldTypeEnum.Describe]: ISearchFormItemType.Null,
  [FieldTypeEnum.PageBreak]: ISearchFormItemType.Null,
  [FieldTypeEnum.Address]: ISearchFormItemType.Null,
  [FieldTypeEnum.Integer]: ISearchFormItemType.Null,
}))

export const roleToLabel = createEnumHelper(() => ({
  [ReflectionRoleEnum.Teacher]: '教师',
  [ReflectionRoleEnum.Student]: '学生',
  [ReflectionRoleEnum.Guardian]: '家长',
  [ReflectionRoleEnum.Staff]: '职工',
  [ReflectionRoleEnum.Shadow]: '超管',
}))

export const genderToLabel = createEnumHelper(() => ({
  [ReflectionGenderEnum.M]: '男',
  [ReflectionGenderEnum.F]: '女',
}))

export const statusToLabel = createEnumHelper(() => ({
  [ReflectionStatusEnum.Normal]: '正常',
  [ReflectionStatusEnum.Archived]: '禁用',
}))

export const statusToColor = createEnumHelper(() => ({
  [ReflectionStatusEnum.Normal]: '#0A6CFF',
  [ReflectionStatusEnum.Archived]: '#F54545',
}))

export const idcardTypeToLabel = createEnumHelper(() => ({
  [ReflectionIdcardTypeEnum.Idcard]: '居民身份证',
  [ReflectionIdcardTypeEnum.MainlandPassForHkAndMacao]:
    '港澳居民来往内地通行证',
  [ReflectionIdcardTypeEnum.MainlandPassForTaiwan]: '台湾居民来往大陆通行证',
  [ReflectionIdcardTypeEnum.Passport]: '护照',
  [ReflectionIdcardTypeEnum.Other]: '其他',
}))

export const guardianTypeToLabel = createEnumHelper(() => ({
  [ReflectionPupilTypeEnum.Father]: '父亲',
  [ReflectionPupilTypeEnum.Mother]: '母亲',
  [ReflectionPupilTypeEnum.Other]: '其他',
}))

export const valueToLabel: { [key: string]: (name: any) => string } = {
  role: (name: ReflectionRoleEnum) => roleToLabel.get(name),
  gender: (name: ReflectionGenderEnum) => genderToLabel.get(name),
  status: (name: ReflectionStatusEnum) => statusToLabel.get(name),
  idcard_type: (name: ReflectionIdcardTypeEnum) => idcardTypeToLabel.get(name),
  'guardians.0.pupil_type': (name: ReflectionPupilTypeEnum) =>
    guardianTypeToLabel.get(name),
  'guardians.1.pupil_type': (name: ReflectionPupilTypeEnum) =>
    guardianTypeToLabel.get(name),
}

export const entryrecordTypeToLabel = createEnumHelper(() => ({
  [EntryrecordLoginTypeEnum.Code]: '手机短信',
  [EntryrecordLoginTypeEnum.Password]: '账号密码',
  [EntryrecordLoginTypeEnum.Unknow]: '未知',
}))
